import { useCallback } from "react";

export function NumInput({
  id,
  value,
  onChange,
  step = "0.01",
  readOnly = false,
  placeholder,
  style,
  min,
  list,
  disabled,
}) {
  const stopScroll = useCallback((e) => e.target.blur(), []);
  return (
    <input
      type="number"
      id={id}
      list={list}
      value={value}
      step={step}
      readOnly={readOnly}
      placeholder={placeholder}
      min={min}
      style={style}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      onWheel={stopScroll}
      disabled={disabled}
    />
  );
}
